import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import { InOtherCartsCardData } from '../rql';
import { useViewTracking } from '../use_tracking';
import { MParticleEventName } from '../elog/mparticle_types';

interface IProps {
  listing: InOtherCartsCardData.Fragment;
  inRedesignExperiment?: boolean;
}

export const InOtherCartsCardFragment = gql`
  fragment InOtherCartsCardData on Listing {
    _id
    id
    otherBuyersWithListingInCartCounts
  }
`;

export function InOtherCartsCardNudge(props: IProps) {
  const { id, otherBuyersWithListingInCartCounts } = props.listing;
  const eligible = !!otherBuyersWithListingInCartCounts &&
    otherBuyersWithListingInCartCounts > 0;

  const mParticleViewData = {
    componentName: 'InOtherCartsCardNudge',
    eventName: MParticleEventName.ComponentView,
    displayStyle: `other_carts:${otherBuyersWithListingInCartCounts}`,
    listingId: id,
  };

  useViewTracking(mParticleViewData, eligible);

  if (!eligible) { return null; }

  if (props.inRedesignExperiment) {
    return (
      <div className="listing-card-nudge listing-card-nudge--carts">
        <div className="listing-card-nudge__icon" />
        {I18n.t(
          'commons.listingNudge.inOtherCarts',
          { count: otherBuyersWithListingInCartCounts },
        )}
      </div>
    );
  }

  return (
    <div className="grid-card__nudge grid-card__nudge--in-other-carts">
      {I18n.t(
        'commons.listingNudge.inOtherCarts',
        { count: otherBuyersWithListingInCartCounts },
      )}
    </div>
  );
}
